import { useEffect, useState } from "react";
// core components
import SnackbarContent from "components/Snackbar/SnackbarContent.js";

const DURATION = 3000;
const COLOR = "info";

export default function Notification(props) {
    const {
        open = false,
        message = "",
        color = COLOR,
        duration = DURATION,
        onClose = () => {},
    } = props;

    const [visible, setVisible] = useState(open);

    useEffect(() => {
        setVisible(open);

        if (!open) return;

        const timer = setTimeout(() => {
            handleClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [open]);

    const handleClose = () => {
        setVisible(false);

        try {
            if (typeof onClose === "function") onClose(false);
        } catch (err) {
            console.error("Error calling onClose:", err);
        }
    };

    if (!visible) return null;

    return (
        <SnackbarContent
            message={message}
            close
            color={color}
            closeNotification={handleClose}
            onClose={handleClose}
        />
    );
}
